<template>
    <div>
        <van-overlay :show="isShow" @click="isShow = false">
            <div class="wrapper" @click.stop>
                <div class="main_container">
                    <!-- 商品信息 -->
                    <div class="product_base_info">
                        <div class="product_name">
                            <p>{{ productInfo.goodsName }}</p>
                        </div>
                        <div class="product_params">
                            <span>{{ productInfo.goodsCode }}</span>
                        </div>
                        <div class="product_brand">
                            <span>{{ productInfo.brandName }}</span>
                        </div>
                    </div>
                    <!-- 商品信息 -->
                    <ul class="returned_info_list">
                        <li
                            class="info_item"
                            v-for="(item, index) in returnedInfoList"
                            :key="index"
                        >
                            <div class="info_params">
                                <span class="info_label">退款服务号</span>
                                <span class="info_value">{{
                                    item.salesReturnNo
                                }}</span>
                            </div>
                            <div class="info_params">
                                <span class="info_label">状态</span>
                                <span class="info_value">{{
                                    item.refundReturnStateDes
                                }}</span>
                            </div>
                            <div class="info_params">
                                <span class="info_label">数量</span>
                                <span class="info_value"
                                    >{{
                                        item.currReturnProductQuantity
                                    }}pcs</span
                                >
                            </div>
                        </li>
                    </ul>
                    <div class="button_container" @click="isShow = false">
                        <span>确定</span>
                    </div>
                </div>
            </div>
        </van-overlay>
    </div>
</template>
<script>
import Vue from "vue";
import { Overlay } from "vant";
Vue.use(Overlay);
export default {
    data() {
        return {
            isShow: false,
            productInfo: {},
            returnedInfoList: [],
        };
    },
    methods: {
        open(productInfo) {
            this.isShow = true;
            this.productInfo = productInfo;
            this.returnedInfoList = productInfo.returnRefundDetailList || [];
        },
    },
};
</script>

<style lang="less" scoped>
.wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
}

.main_container {
    width: 560px;
    padding: 0px 30px;
    background-color: #fff;
    > .product_base_info {
        padding: 30px 0;
        font-size: 24px;
        border-bottom: 1px solid #f2f2f2;
        > .product_name {
            word-break: break-all;
        }
        > .product_params {
            padding: 5px 0;
            color: #999;
        }
        > .product_brand {
            color: #999;
        }
    }
    > .returned_info_list {
        max-height: 420px;
        overflow-y: auto;
        > .info_item {
            margin-bottom: 30px;
            padding: 30px 0;
            border-bottom: 1px solid #f2f2f2;
            &:last-child {
                margin-bottom: 0px;
            }
            > .info_params {
                font-size: 24px;
                margin-bottom: 10px;
                &:last-child {
                    margin-bottom: none;
                }
                > .info_label {
                    *display: inline;
                    display: inline-block;
                    width: 150px;
                    color: #999;
                }
                > .info_value {
                    *display: inline;
                    display: inline-block;
                    width: 410px;
                    color: #333;
                }
            }
        }
    }
    .button_container {
        height: 100px;
        font-size: 32px;
        line-height: 100px;
        text-align: center;
        color: #4bc227;
    }
}
</style>
